import React from 'react';
import {useDashboard} from "../../../utilities/context/dashboard/dashboard-context";

const Profile = () => {

    const {user} = useDashboard();

    return (
        <div className="text-left border-b p-2 flex flex-col md:flex-row items-center gap-4">
            <img src={user.image_url}
                 alt={"logo"}
                className={`w-32 ${user.image_url ? "" : "hidden"}`}/>
            <div>
                <div className="uppercase text-gray-200 text-xs font-medium">Profilo</div>
                <div className="text-2xl">{user.name}</div>
                <div className="text-xl">{user.email}</div>
            </div>
        </div>
    );
};

export default Profile;